import {useEffect} from 'react';
import affiliateAnalytics from '@xo-union/affiliate-marketing-analytics';
import sha1 from 'crypto-js/sha1';
import noop from '../../../../utils/noop';

const getMemberIdentifyArgs = ({
  id,
  legacy_user_id: legacyUserId,
  email,
  first_name: firstName,
  last_name: lastName,
  fiance_first_name: fianceFirstName,
  fiance_last_name: fianceLastName,
}) => [
  legacyUserId,
  {
    email,
    firstName,
    lastName,
    fianceFirstName,
    fianceLastName,
    memberId: id,
  },
];

/**
 * Identifies the member using Segment and affiliate analytics.
 * Consent is handled server-side via registry-react-scripts compliance configuration.
 */
const useIdentifyMember = (member = null, isLoggedIn = false) => {
  useEffect(() => {
    if (!member) {
      if (!isLoggedIn) {
        affiliateAnalytics.identify();
      }

      return undefined;
    }

    window.analytics.identify(...getMemberIdentifyArgs(member));

    affiliateAnalytics.identify({
      customerId: member.id,
      customerEmail: sha1(member.email),
    });

    return noop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member, isLoggedIn]);
};

export default useIdentifyMember;
